import FadeUp from "../components/site/FadeUp";
import CTASection from "../components/site/CTASection";
import { FAQS } from "../data/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <section className="section-pad">
        <div className="container-hh max-w-3xl">
          <FadeUp>
            <p className="eyebrow">Good questions</p>
            <h1 className="mt-3 text-4xl md:text-5xl lg:text-6xl">
              Everything you might be wondering
            </h1>
            <p className="mt-5 text-lg leading-relaxed text-bodytext">
              And if there's something here we didn't cover, just ask — we're
              happy to talk it through.
            </p>
          </FadeUp>

          <FadeUp delay={0.1} className="mt-10">
            <Accordion type="single" collapsible data-testid="faq-accordion" className="space-y-3">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="rounded-[12px] border-none bg-white px-6 shadow-cozy"
                >
                  <AccordionTrigger className="py-5 text-left font-serif text-xl text-navy hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-base leading-relaxed text-bodytext">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </FadeUp>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
